// @ts-ignore
import content from './md/built-for-home-services-vs-generic.md';

export const meta = {
  slug: 'built-for-home-services-vs-generic',
  title: 'Built for Home Services vs. Built for Everyone: Why Industry-Specific CRMs Outperform Generic Solutions',
  excerpt: 'Generic CRMs serve millions of businesses but require hours of configuration. Discover why industry-specific tools deliver better results with less effort.',
  date: 'January 2025',
  readTime: '10 min read',
  image: '/docs/built-for-home-services-vs-generic/header.png'
};

export { content };
